/* ==========================================================================
   MADHOURS - hand the bundle widget back to the Kaching app.

   sections/product-section-2.liquid renders an inline <style> block that
   restyles Kaching to the old MADHOURS look: 29 selectors forcing
   `background: transparent !important` (which is what flattens the red timer
   bar and the grey tier fills), 1px outline borders on the tier boxes,
   uppercase + wide tracking on every label, and an outlined "Choose" button.

   That styling predates the bundle being designed inside Kaching itself. Now
   that the app owns the design, those rules are actively fighting it - the
   storefront could never match the app preview while they were live.

   Because the block is inline in the section body it loads AFTER every
   mh-*.css link, so a stylesheet cannot outrank it at equal specificity.
   Rather than mirror 29 selectors at higher specificity - which would have to
   be re-guessed every time the merchant changes something in Kaching - this
   removes the block outright, leaving the app's own CSS as the only thing
   styling the widget.

   Identification is deliberately narrow: a <style> that mentions Kaching's
   block class AND the MADHOURS ink variable. The app's own stylesheet has no
   --mh-* variables, so it can never match.

   TODO (source cleanup): delete the same block from
   sections/product-section-2.liquid so this file is no longer needed.
   ========================================================================== */
(function () {
  'use strict';

  function strip() {
    var removed = 0;
    var tags = document.querySelectorAll('style');
    Array.prototype.forEach.call(tags, function (tag) {
      var css = tag.textContent || '';
      if (css.indexOf('kaching-bundles__') === -1) return;
      // the app's own sheet never references our design tokens
      if (css.indexOf('--mh-ink') === -1 && css.indexOf('--mh-line') === -1) return;
      tag.parentNode.removeChild(tag);
      removed++;
    });
    return removed;
  }

  strip();

  // The section can re-render (theme editor, variant change), which re-injects
  // the block. Watch briefly rather than forever - a few seconds covers every
  // re-render path without leaving an observer running for the whole session.
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () { strip(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
  }
})();
